/* eslint-disable */

import {
  Animation,
  Color3,
  EasingFunction,
  ExponentialEase,
  Quaternion,
  QuinticEase,
  Vector3,
} from "babylonjs";

import { ref } from "vue";
import store from "./store";

enum AnimationStatus {
  Idle,
  AnimatingIn,
  AnimatingOut,
  Waiting,
}

const animationFPS = 30;

const animating = ref<boolean>(false);
const animationStatus = ref<AnimationStatus>(AnimationStatus.Idle);

function animateProperty(
  obj: any,
  property: string,
  animationLength: number,
  from: any,
  to: any,
  animationType: number
): number {
  const animation = new Animation("AnimateFloat", property, 30, animationType);

  obj[property] = from;

  const keys = [
    { frame: 0, value: from },
    { frame: animationLength, value: to },
  ];

  animation.setKeys(keys);

  const ease = new QuinticEase();
  ease.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);

  animation.setEasingFunction(ease);

  store.scene.beginDirectAnimation(obj, [animation], 0, animationLength, false);

  return animationLength * animationFPS;
}

function animatePropertyFloat(
  obj: any,
  property: string,
  animationLength: number,
  from: number,
  to: number
): number {
  return animateProperty(
    obj,
    property,
    animationLength,
    from,
    to,
    Animation.ANIMATIONTYPE_FLOAT
  );
}

function animatePropertyQuaternion(
  obj: any,
  property: string,
  animationLength: number,
  from: Quaternion,
  to: Quaternion
): number {
  return animateProperty(
    obj,
    property,
    animationLength,
    from,
    to,
    Animation.ANIMATIONTYPE_QUATERNION
  );
}

function animatePropertyVector3(
  obj: any,
  property: string,
  animationLength: number,
  from: Vector3,
  to: Vector3
): number {
  return animateProperty(
    obj,
    property,
    animationLength,
    from,
    to,
    Animation.ANIMATIONTYPE_VECTOR3
  );
}

function animatePropertyColor(
  obj: any,
  property: string,
  animationLength: number,
  from: Color3,
  to: Color3
): number {
  return animateProperty(
    obj,
    property,
    animationLength,
    from,
    to,
    Animation.ANIMATIONTYPE_COLOR3
  );
}

function setAnimating(val: boolean) {
  // console.log('animation: ', val)
  animating.value = val;
}

function setAnimationStatus(status: AnimationStatus) {
  // console.log("animation status: ", status);
  animationStatus.value = status;
}

export {
  animatePropertyFloat,
  animatePropertyQuaternion,
  animatePropertyVector3,
  animatePropertyColor,
  setAnimating,
  setAnimationStatus,
  AnimationStatus,
  animating,
  animationStatus,
};
